import {makeGet} from '@yandex-delivery/utils'
import {Fragment} from 'react'
import type {SharedRouteInfoResponse as RouteInfo} from 'src/api/types'

import {classes} from './Status.classes'

export function renderVehiclePlate(str: string = ''): React.ReactElement[] {
  return str
    .split(/(\d+)/)
    .filter(Boolean)
    .map(strOrNumber =>
      !Number.isNaN(+strOrNumber) ? (
        <span className={classes.plateNumbers} key={strOrNumber}>
          {strOrNumber}
        </span>
      ) : (
        <Fragment key={strOrNumber}>{strOrNumber}</Fragment>
      ),
    )
}

export const infoGet = makeGet<RouteInfo>()
